// rulesGameType — только для просмотра записи (REPLAY): по правилам какого
// режима проигрывать запись. Запись локальной партии (прохождение обучения)
// идет по локальным правилам — см. getRulesGameType
export const setGameType = (gameType, {rulesGameType} = {}) => ({
  type: 'SET_GAME_TYPE',
  payload: rulesGameType ? {gameType, rulesGameType} : {gameType}
});

// Режим планировщика у ботов локальной партии (волна 29): включается только
// админом на HotSeatPlayersInitPage перед стартом матча
export const setBotsPlannerMode = (isEnabled) => ({
  type: 'SET_BOTS_PLANNER_MODE',
  payload: {isEnabled}
});

export const setSelectedToken = (tokenType) => ({
  type: 'SET_SELECTED_TOKEN',
  payload: tokenType,
  noServerSync: true
});

export const clearHex = (key) => ({
  type: 'CLEAR_HEX',
  payload: key
});

// isRuinsIncomeByRoundLimit, isCitylessEconomyRule, isPlayerBonusPerCityRule,
// isLastStandingEndRule, isCentralQuarterFortressDamageRule и
// isBuildingWinPointsInCitiesRule — метки правил: партия считает окно дохода
// руин от своего лимита раундов (см. getRuinsIncomeRoundLimit), живет по
// правилу «без городов — без монет» (см. checkIfCitylessEconomyRule), по
// бонусу дохода за каждый город (см. checkIfPlayerBonusPerCityRule),
// заканчивается, когда в живых остался один игрок (см.
// checkIfLastStandingEndRule), крепость на центральном квартале получает урон
// от стрельбы и при целых базовых кварталах (см.
// checkIfCentralQuarterFortressDamageRule), а строение вне города не отнимает
// очков (см. checkIfBuildingWinPointsInCitiesRule). Метки ставит каждая новая
// загрузка поля, и они попадают в запись матча вместе с экшеном;
// в LOAD_STATE старых записей их нет — они проигрываются по старым правилам
export const loadState = (loadedState, finalRound) => ({
  type: 'LOAD_STATE',
  payload: {
    loadedState,
    finalRound,
    isRuinsIncomeByRoundLimit: true,
    isCitylessEconomyRule: true,
    isPlayerBonusPerCityRule: true,
    isLastStandingEndRule: true,
    isCentralQuarterFortressDamageRule: true,
    isBuildingWinPointsInCitiesRule: true,
  },
  noServerSync: true
});

export const clearAllHexes = () => ({
  type: 'CLEAR_ALL_HEXES',
  payload: {},
});

// isRanked кладется в состояние партии, а не только в лобби: лобби живет
// только у участников матча, а при просмотре ЗАПИСИ его нет вовсе — без этого
// признака модалка итогов не показывала бы изменение рейтинга (см. GameEndContent)
// groundBackground — подложка поля (см. configs/groundBackgrounds). Выбирается
// ОДИН раз снаружи, как и initiativeShift: этот экшен переигрывается при
// воспроизведении записи матча, и случайность внутри редьюсера показала бы
// зрителю не тот пейзаж, что видели игроки
// options — признаки промо-матча против ИИ («Битва с AI»), их ставит только
// сервер: isAiMatch, chatEnabled (модерируемый чат матча) и
// playerTurnTimeOverrides — персональное время хода {[playerId]: {durationMs,
// isActive}} (у ИИ свой предохранитель вместо общего таймера). Остальные
// вызовы опций не передают — в payload их тогда нет вовсе, и старые записи
// матчей воспроизводятся как раньше
export const startGame = (timestamp, timerEnabled = true, fastMode = false, initiativeShift, isRanked = false, groundBackground = null, isParallelSupply = false, options = {}) => ({
  type: 'START_GAME',
  payload: {
    timestamp, timerEnabled, fastMode, initiativeShift, isRanked, groundBackground, isParallelSupply,
    ...(options?.isAiMatch ? {isAiMatch: true} : {}),
    ...(options?.chatEnabled ? {chatEnabled: true} : {}),
    ...(options?.playerTurnTimeOverrides ? {playerTurnTimeOverrides: options.playerTurnTimeOverrides} : {}),
  }
});

// Признак рейтинговой партии отдельным экшеном: нужен ЗАПИСЯМ, сделанным до
// того, как он стал приходить вместе со START_GAME — тогда его достают из
// карточки матча (см. handleWatchReplay)
// Итоговые награды и рейтинг. В живом матче их присылает сервер; здесь —
// для ЗАПИСЕЙ, сделанных до того, как этот экшен стал попадать в запись
export const setExtendedGameResults = (results) => ({
  type: 'SET_EXTENDED_GAME_RESULTS',
  payload: results,
  noServerSync: true,
});

// Досрочный конец партии итогами текущего раунда (см. GAME_END_REASONS) —
// только серверный: клиенты его не отправляют, от клиентов он не
// ретранслируется (noServerSync) и применяется лишь из серверной рассылки
export const endGameAtCurrentRound = (reason) => ({
  type: 'END_GAME_AT_CURRENT_ROUND',
  payload: {reason},
  noServerSync: true,
});

export const setMatchIsRanked = (isRanked) => ({
  type: 'SET_MATCH_IS_RANKED',
  payload: {isRanked},
  noServerSync: true,
});

export const setServerTimeDelta = (delta) => ({
  type: 'SET_SERVER_TIME_DELTA',
  payload: delta,
  noServerSync: true,
});

// Блокировка ввода после нуля таймера хода (utils/gameState/turn/turnInputLock):
// время игрока вышло, а сервер ход еще не закрыл — до закрытия действия этого
// хода не принимаются. turnKey — ключ хода (getTurnInputLockKey)
export const lockTurnInput = (turnKey) => ({
  type: 'LOCK_TURN_INPUT',
  payload: {turnKey},
  noServerSync: true,
});

// Предохранитель: закрытие от сервера так и не пришло — ввод снова открыт, и
// для этого хода блокировка больше не ставится
export const releaseTurnInput = (turnKey) => ({
  type: 'RELEASE_TURN_INPUT',
  payload: {turnKey},
  noServerSync: true,
});

export const setStartingQuarter = (playerId, hexKey) => ({
  type: 'SET_STARTING_QUARTER',
  payload: {playerId, hexKey}
});

export const confirmSetupPhase = (playerId) => ({
  type: 'CONFIRM_SETUP_PHASE',
  payload: {playerId}
});

// Игрок playerId закончил свою часть ОДНОВРЕМЕННОЙ фазы снабжения сетевой
// игры (см. utils/gameState/supply/parallelSupply). Саму фазу закрывает
// сервер, когда закончили все
export const completePlayerSupply = (playerId, guard = {}) => ({
  type: 'COMPLETE_PLAYER_SUPPLY',
  payload: {playerId, ...guard}
});

export const completePhase = (timestamp, guard = {}) => ({
  type: 'COMPLETE_PHASE',
  payload: {
    ...(timestamp !== undefined && {timestamp}),
    ...guard,
  }
});

export const startNextPhase = (timestamp, newPolicy, guard = {}) => ({
  type: 'START_NEXT_PHASE',
  payload: {
    ...(timestamp ? {timestamp} : {}),
    newPolicy,
    ...guard,
  }
});

export const setHexToken = (key, tokenType, price, isCommiting, isFreeAction) => ({
  type: 'SET_HEX_TOKEN',
  payload: {key, tokenType, price, isCommiting, isFreeAction}
});

// hintId — подсказка из TOAST_HINTS (utils/toast/toastHintsStorage): тост
// предлагает ее отключить. Проверять, не отключена ли она, — вызывающему
export const showToast = (message, type = 'info', duration = 3000, noSound, noHideOnTurnEnd, hintId) => ({
  type: 'SHOW_TOAST',
  payload: {message, type, duration, noSound, noHideOnTurnEnd, hintId},
  noServerSync: true
});

/**
 * Тост со своей иконкой на язычке вместо значка типа: перехват инициативы, кража монет и
 * другие события, которые узнаются по картинке
 * @param {Object} toastAction - результат showToast
 * @param {string} icon - см. TOAST_ICONS
 */
export const withToastIcon = (toastAction, icon) => ({
  ...toastAction,
  payload: {...toastAction.payload, icon},
});

/**
 * Сообщение в чат матча. Обычный игровой экшен (без noServerSync): уходит на
 * сервер, попадает в общее состояние и в запись матча, поэтому переписка
 * видна в реплее. Функция только для локальной разработки — вне dev сервер
 * такие экшены отбрасывает и никому не ретранслирует.
 */
export const addChatMessage = (fromPlayerId, fromPlayerName, text, sentAt) => ({
  type: 'ADD_CHAT_MESSAGE',
  payload: {fromPlayerId, fromPlayerName, text, sentAt},
});

export const showToastWaitOtherPlayerTurn = (currentPlayer) => ({
  type: 'SHOW_TOAST_WAIT_OTHER_PLAYER_TURN',
  payload: {currentPlayer},
  noServerSync: true
});

// Выбор ячейки для просмотра информации в футере во время чужого хода
export const setInspectedHex = (hexKey) => ({
  type: 'SET_INSPECTED_HEX',
  payload: {hexKey},
  noServerSync: true
});

export const clearInspectedHex = () => ({
  type: 'CLEAR_INSPECTED_HEX',
  noServerSync: true
});

// === Реакции игроков (openspec/changes/reaction-messages) ===
// Все экшены реакций строго noServerSync: networkMiddleware иначе отзеркалит
// их на сервер через RELAY_ACTION (в серверный стор и всем игрокам).
// Доставка адресатам идет отдельным WS-типом SEND_REACTION мимо редьюсеров

// Своя отправленная реакция — в очередь тостов приватного стейта
export const enqueueOwnReaction = (fromPlayerId, toPlayerId, reactionType) => ({
  type: 'ENQUEUE_OWN_REACTION',
  payload: {fromPlayerId, toPlayerId, reactionType},
  noServerSync: true
});

// Скрытие текущего тоста-реакции по таймауту — удаляет первый элемент очереди
export const dequeueReaction = () => ({
  type: 'DEQUEUE_REACTION',
  noServerSync: true
});

// Мут реакций игрока до конца матча (только в памяти клиента)
export const mutePlayerReactions = (playerId) => ({
  type: 'MUTE_PLAYER_REACTIONS',
  payload: {playerId},
  noServerSync: true
});

export const hideToast = () => ({
  type: 'HIDE_TOAST',
  noServerSync: true
});

/**
 * Тост «игрок купил политику» в матче (MatchPolicyToast). Диспатчится из
 * playEffectForServerAction на BUY_POLICY — как и остальные тосты, это чисто
 * клиентское уведомление (noServerSync)
 */
export const showPolicyPurchaseToast = (playerId, policy) => ({
  type: 'SHOW_POLICY_PURCHASE_TOAST',
  payload: {playerId, policy},
  noServerSync: true
});

export const hidePolicyPurchaseToast = () => ({
  type: 'HIDE_POLICY_PURCHASE_TOAST',
  noServerSync: true
});

export const moveUnit = (unitId, unitType, newHexKey) => ({
  type: 'MOVE_UNIT',
  payload: {unitId, unitType, newHexKey}
});

export const setPlayers = (players) => ({
  type: 'SET_PLAYERS',
  payload: {players}
});

export const setPolicyMarket = (policyMarket) => ({
  type: 'SET_POLICY_MARKET',
  payload: {policyMarket},
  noServerSync: true
});


export const clearPolicyMarket = (policyMarket) => ({
  type: 'CLEAR_POLICY_MARKET',
  payload: {policyMarket}
});

export const buyPolicy = (index) => ({
  type: 'BUY_POLICY',
  payload: {index},
});

export const addNewPolicyToPolicyMarket = (policy) => ({
  type: 'ADD_NEW_POLICY_TO_POLICY_MARKET',
  payload: {policy},
});

export const selectUnit = (unitId) => ({
  type: 'SELECT_UNIT',
  payload: {unitId},
  noServerSync: true
});

export const deselectUnit = () => ({
  type: 'DESELECT_UNIT',
  noServerSync: true
});

// Выбор отряда автовыбором (change unit-auto-selection): тот же SELECT_UNIT,
// но с пометкой — обучение такой выбор не копит, а камера подводит кадр
export const autoSelectUnit = (unitId) => ({
  ...selectUnit(unitId),
  meta: {auto: true},
});

// Пропуск хода отрядом на этапе войны. skipKey — раунд, фаза, этап и игрок
// (getUnitTurnSkipKey): пропуск действует, только пока ключ совпадает с
// текущим этапом. Только у клиента — ни ретрансляции, ни записи матча
export const skipUnitTurn = (unitId, skipKey) => ({
  type: 'SKIP_UNIT_TURN',
  payload: {unitId, skipKey},
  noServerSync: true
});

export const setUnitAutoSelectionEnabled = (isEnabled) => ({
  type: 'SET_UNIT_AUTO_SELECTION_ENABLED',
  payload: {isEnabled},
  noServerSync: true
});

export const showMeleeTargetsForPrioritySelect = () => ({
  type: 'SHOW_MELEE_TARGETS_FOR_PRIORITY_SELECT',
  noServerSync: true
});
export const hideMeleeTargetsForPrioritySelect = () => ({
  type: 'HIDE_MELEE_TARGETS_FOR_PRIORITY_SELECT',
  noServerSync: true
});

// === NEW: layers visibility ===
export const toggleUnitsVisible = () => ({
  type: 'TOGGLE_UNITS_VISIBLE',
  noServerSync: true
});
export const toggleHexCoordinatesVisible = () => ({
  type: 'TOGGLE_HEX_COORDINATES_VISIBLE',
  noServerSync: true
});
export const toggleIncomeVisible = () => ({
  type: 'TOGGLE_INCOME_VISIBLE',
  noServerSync: true
});
export const toggleCityOwnershipVisible = () => ({
  type: 'TOGGLE_CITY_OWNERSHIP_VISIBLE',
  noServerSync: true
});
export const toggleBlockedCellsVisible = () => ({
  type: 'TOGGLE_BLOCKED_CELLS_VISIBLE',
  noServerSync: true
});
export const toggleGuildVisible = () => ({
  type: 'TOGGLE_GUILD_VISIBLE',
  noServerSync: true
});
export const toggleTempleVisible = () => ({
  type: 'TOGGLE_TEMPLE_VISIBLE',
  noServerSync: true
});
export const toggleFortressVisible = () => ({
  type: 'TOGGLE_FORTRESS_VISIBLE',
  noServerSync: true
});
export const toggleQuarterZoneVisible = () => ({
  type: 'TOGGLE_QUARTER_ZONE_VISIBLE',
  noServerSync: true
});
export const setQuarterZoneVisible = (isVisible) => ({
  type: 'SET_QUARTER_ZONE_VISIBLE',
  payload: isVisible,
  noServerSync: true
});

// === Combat system actions ===
// isDice3Selected/isDice4Selected — только у отрядов с 4 костями (селестиалы);
// флаги выбора нужны лишь для звука переброса у всех клиентов (кости уже в
// meleeCombatInput), поэтому у обычных отрядов в payload их нет
export const calculateMeleeCombatDamage = (meleeCombatInput, rerollUnitId, priorityTargetForUnit, isReroll, isBadLuck, isDice1Selected, isDice2Selected, isDice3Selected, isDice4Selected) => ({
  type: 'CALCULATE_MELEE_COMBAT_DAMAGE',
  payload: {
    meleeCombatInput,
    rerollUnitId,
    priorityTargetForUnit,
    isReroll,
    isBadLuck,
    isDice1Selected,
    isDice2Selected,
    ...(isDice3Selected !== undefined || isDice4Selected !== undefined ? {isDice3Selected, isDice4Selected} : {}),
  }
});

export const confirmCombatStage = (playerId) => ({
  type: 'CONFIRM_COMBAT_STAGE',
  payload: {playerId}
});

// Выбор казармы для найма нового отряда — обратный порядок действий на этапе
// найма: сначала казарма, потом тип отряда в футере (см. GameScene и
// WarRecruitmentStageToolbar). Чисто клиентский выбор, серверу не нужен
export const selectBarracksForRecruitment = (barracksHexKey) => ({
  type: 'SELECT_BARRACKS_FOR_RECRUITMENT',
  payload: {barracksHexKey},
  noServerSync: true
});

export const deselectBarracksForRecruitment = () => ({
  type: 'DESELECT_BARRACKS_FOR_RECRUITMENT',
  noServerSync: true
});

// === Supply system actions ===
// isAuto — ферму выделила панель снабжения, а не игрок (см. SupplyPanel)
export const selectFarm = (farmHexKey, {isAuto = false} = {}) => ({
  type: 'SELECT_FARM',
  payload: {farmHexKey, ...(isAuto && {isAuto})},
  noServerSync: true
});

// Игрок отказался от автовыбора фермы до конца своей раздачи: осмотрел ячейку или снял выбор.
// Ключ — раунд и игрок (getSupplyTurnKey): в следующем снабжении автовыбор снова работает
export const declineSupplyAutoFarm = (turnKey) => ({
  type: 'DECLINE_SUPPLY_AUTO_FARM',
  payload: {turnKey},
  noServerSync: true
});

export const deselectFarm = () => ({
  type: 'DESELECT_FARM',
  noServerSync: true
});

export const distributeSupply = (farmHexKey, unitId, unitHexKey, isAutoSupply, isNotUndoable, isRatmenRecruitment, playerId) => ({
  type: 'DISTRIBUTE_SUPPLY',
  payload: {farmHexKey, unitId, unitHexKey, isAutoSupply, isNotUndoable, isRatmenRecruitment, ...(playerId !== undefined && {playerId})}
});

// Удаление последнего отложенного действия снабжения (для отмены в фазе снабжения).
// Пустой payload здесь и у других игровых экшенов без данных — не формальность:
// в него networkMiddleware кладет слепок контекста хода, по которому сервер
// отбрасывает запоздавшее действие (см. buildGuardedRelayAction). Без payload
// отмена, долетевшая после завершения хода по таймеру, сняла бы снабжение
// уже следующего игрока
export const undoPendingSupplyAction = (playerId) => ({
  type: 'UNDO_PENDING_SUPPLY_ACTION',
  payload: {...(playerId !== undefined && {playerId})},
});

// Сброс всех отменяемых действий снабжения — кнопка «Распределить заново» в
// футере фазы снабжения (игрок раздает снабжение с нуля руками)
export const resetPendingSupply = (playerId) => ({
  type: 'RESET_PENDING_SUPPLY',
  payload: {...(playerId !== undefined && {playerId})},
});

// Точечная отмена снабжения ОТРЯДА (двойной клик по отряду в фазе снабжения):
// первым снимается дополнительное снабжение, повторным вызовом — базовое
export const undoUnitPendingSupply = (unitId, playerId) => ({
  type: 'UNDO_UNIT_PENDING_SUPPLY',
  payload: {unitId, ...(playerId !== undefined && {playerId})}
});

// Точечная отмена снабжения, отданного С ФЕРМЫ (двойной клик по ферме в фазе
// снабжения): снимается последнее отданное с нее снабжение, единица
// возвращается ферме
export const undoFarmPendingSupply = (farmHexKey, playerId) => ({
  type: 'UNDO_FARM_PENDING_SUPPLY',
  payload: {farmHexKey, ...(playerId !== undefined && {playerId})}
});

// === Giants ===
// Выбор великана для показа в GiantsSupplyToolbar (счётчик снабжения + кнопка
// конвертации) - чисто отображательное, на раздачу снабжения не влияет
export const giantsSelectUnitForAdditionalSupply = (unitId, playerId) => ({
  type: 'GIANTS_SELECT_UNIT_FOR_ADDITIONAL_SUPPLY',
  payload: {unitId, ...(playerId !== undefined && {playerId})}
});

export const giantsResetAdditionalSupplySelection = (playerId) => ({
  type: 'GIANTS_RESET_ADDITIONAL_SUPPLY_SELECTION',
  payload: {...(playerId !== undefined && {playerId})},
});

// Батч доп. снабжения за конкретные фермы - используется авто-раздачей
// (executePhaseAutoActions/GiantsAutoSupplyToggle), не ручным кликом игрока
// (тот идёт через кнопку "Дать доп." -> giantsConvertSupply)
export const distributeGiantsAdditionalSupply = (farmHexKeys, unitId, playerId) => ({
  type: 'DISTRIBUTE_GIANTS_ADDITIONAL_SUPPLY',
  payload: {farmHexKeys, unitId, ...(playerId !== undefined && {playerId})}
});

// Тумблер политики авто-раздачи снабжения (см. GiantsAutoSupplyToggle) - персональный
// для каждого игрока-великана, переключает currentPlayer.isGiantsAutoAdditionalSupplyOn
export const giantsToggleAutoAdditionalSupply = (playerId) => ({
  type: 'GIANTS_TOGGLE_AUTO_ADDITIONAL_SUPPLY',
  payload: {...(playerId !== undefined && {playerId})},
});

// Конвертация уже полученного великаном снабжения: 4 базовых <-> 1 дополнительное
// (в обе стороны, реверс определяется reducer'ом по текущему состоянию отряда)
export const giantsConvertSupply = (unitId, playerId) => ({
  type: 'GIANTS_CONVERT_SUPPLY',
  payload: {unitId, ...(playerId !== undefined && {playerId})}
});

// === NEW: War phase stage ===
export const setWarPhaseStage = (stage, timestamp, guard = {}) => ({
  type: 'SET_WAR_PHASE_STAGE',
  payload: {
    stage,
    ...(timestamp ? {timestamp} : {}),
    ...guard,
  }
});

export const setTurnEndTimestamp = (timestamp) => ({
  type: 'SET_TURN_END_TIMESTAMP',
  payload: {timestamp},
  noServerSync: true
});

// Окно облета захваченных городов во времени хода (см.
// getCityCaptureStageExtraMs) — рассылает сервер после захвата, присланного
// клиентом: сам клиент считал захват без серверного времени
export const setCityCaptureTimeWindow = (cityCaptureTimeWindow) => ({
  type: 'SET_CITY_CAPTURE_TIME_WINDOW',
  payload: {cityCaptureTimeWindow},
  noServerSync: true
});

export const setInvalidPendingBuildings = (invalidHexKeys) => ({
  type: 'SET_INVALID_PENDING_BUILDINGS',
  payload: {invalidHexKeys}
});

// transferAgrarianismBenefit — редьюсер передает льготу «первой фермы хода»
// следующей ферме, если первую отменили вне очереди (см. UNDO_PENDING_BUILDING).
// Флаг в самом экшене, а не безусловное правило: записи матчей, сделанные до
// этого правила, воспроизводятся по тем правилам, по которым игрались
export const undoPendingBuilding = (hexKey, token, price, previousToken) => ({
  type: 'UNDO_PENDING_BUILDING',
  payload: {hexKey, token, price, previousToken, transferAgrarianismBenefit: true}
});

// === Планирование строительства в сетевой игре ===
// Чисто клиентские экшены: план живет только в приватном состоянии игрока и на
// сервер не уходит (см. constructionPlanReducer, constructionPlanMiddleware)

// Строение, которое игрок размечает на поле в чужой ход (null — не выбрано)
export const setConstructionPlanBrush = (token = null) => ({
  type: 'SET_CONSTRUCTION_PLAN_BRUSH',
  payload: {token},
  noServerSync: true
});

export const addConstructionPlanEntry = (hexKey, token) => ({
  type: 'ADD_CONSTRUCTION_PLAN_ENTRY',
  payload: {hexKey, token},
  noServerSync: true
});

// Снимает верхнее запланированное строение на ячейке (клик по нему):
// спецстроение на запланированном квартале снимается раньше самого квартала
export const removeConstructionPlanEntry = (hexKey = null) => ({
  type: 'REMOVE_CONSTRUCTION_PLAN_ENTRY',
  payload: {hexKey},
  noServerSync: true
});

// Снимает все запланированное на ячейках: на ячейке построился ходящий игрок
export const removeConstructionPlanEntriesAt = (hexKeys = []) => ({
  type: 'REMOVE_CONSTRUCTION_PLAN_ENTRIES_AT',
  payload: {hexKeys},
  noServerSync: true
});

// Снимает ровно эти записи плана ({hexKey, token}), не трогая остальное
// запланированное на тех же ячейках: например, квартал соперника рядом снимает
// запланированный квартал, а дорогу под ним оставляет
export const removeConstructionPlanEntries = (entries = []) => ({
  type: 'REMOVE_CONSTRUCTION_PLAN_ENTRIES',
  payload: {entries},
  noServerSync: true
});

export const removeLastConstructionPlanEntry = () => ({
  type: 'REMOVE_LAST_CONSTRUCTION_PLAN_ENTRY',
  noServerSync: true
});

export const clearConstructionPlan = () => ({
  type: 'CLEAR_CONSTRUCTION_PLAN',
  noServerSync: true
});

// План забран в применение в начале хода turnKey (см. getConstructionPlanTurnKey)
export const markConstructionPlanApplied = (turnKey = null) => ({
  type: 'MARK_CONSTRUCTION_PLAN_APPLIED',
  payload: {turnKey},
  noServerSync: true
});

// Вернуть примененный план для повторного применения: действия плана не дошли
// до сервера (соединение оборвалось), см. constructionPlanMiddleware. Вместе с
// планом возвращается и выбор автоматического завершения хода
export const restoreConstructionPlan = (entries = [], isAutoCompleteTurn = false) => ({
  type: 'RESTORE_CONSTRUCTION_PLAN',
  payload: {entries, isAutoCompleteTurn},
  noServerSync: true
});

// Чекбокс «Автоматически завершить ход»: в начале своего хода план
// применяется, и ход сразу завершается (см. constructionPlanMiddleware)
export const setConstructionPlanAutoCompleteTurn = (isEnabled = false) => ({
  type: 'SET_CONSTRUCTION_PLAN_AUTO_COMPLETE_TURN',
  payload: {isEnabled},
  noServerSync: true
});

// Ячейки запланированных строений, не прошедших проверку плана
// (validateConstructionPlan), — на них красные молотки
export const setConstructionPlanInvalidHexKeys = (hexKeys = []) => ({
  type: 'SET_CONSTRUCTION_PLAN_INVALID_HEX_KEYS',
  payload: {hexKeys},
  noServerSync: true
});

export const recruitUnit = (hexKey, unitType, factionId, price, unitId, isRatmenForSupplyRecruitment, playerId) => ({
  type: 'RECRUIT_UNIT',
  payload: {hexKey, unitType, factionId, price, unitId, isRatmenForSupplyRecruitment, ...(playerId !== undefined && {playerId})}
});

export const addPendingRecruitmentAction = (unitId, actionType, quarterHexKey, price, sizeAdded) => ({
  type: 'ADD_PENDING_RECRUITMENT_ACTION',
  payload: {unitId, actionType, quarterHexKey, price, sizeAdded}
});

export const undoPendingRecruitmentAction = (lastRecruitmentAction) => ({
  type: 'UNDO_PENDING_RECRUITMENT_ACTION',
  payload: {lastRecruitmentAction}
});

export const addPendingMovementAction = (unitId, fromHexKey, toHexKey, additionalSupply = false) => ({
  type: 'ADD_PENDING_MOVEMENT_ACTION',
  payload: {unitId, fromHexKey, toHexKey, additionalSupply}
});

// Без unitId — отмена последнего перемещения (кнопка отмены); с unitId —
// перемещения этого отряда вне очереди (двойной клик по нему)
export const undoPendingMovementAction = (unitId) => ({
  type: 'UNDO_PENDING_MOVEMENT_ACTION',
  payload: unitId ? {unitId} : {},
});

export const toggleDestructionTool = () => ({
  type: 'TOGGLE_DESTRUCTION_TOOL',
  noServerSync: true
});

// Чисто клиентский выбор режима способности Гоблинов в тулбаре этапа
// способностей ('SET_TRAP' | 'REMOVE_TRAP' | 'DAMAGE_BUILDING') - не
// синхронизируется по сети
export const setGoblinsAbilityMode = (mode) => ({
  type: 'SET_GOBLINS_ABILITY_MODE',
  payload: {mode},
  noServerSync: true
});

// Отображение срабатывания ловушки(ек) по отряду - индикаторы на поле для
// ВСЕХ клиентов (см. HexGridRenderer.updateGoblinsTrapTriggerDisplay) плюс,
// только когда blocking: true, блокирующее уведомление на клиенте игрока-
// человека, чей отряд двигался (см. design.md Decision 12/20/21). Чисто
// клиентское, не синхронизируется по сети - каждый клиент, увидевший экшен
// APPLY_GOBLINS_TRAP_MOVEMENT (свой диспатч или релей), диспатчит это
// самостоятельно с теми же данными. Имя действия сохранено (изначально было
// только для гибели), чтобы не трогать лишние места
// @param {{unit, died, finalHexKey, totalDamageTaken, triggeredTrapEvents, blocking}} details
export const showGoblinsTrapKillNotice = (details) => ({
  type: 'SHOW_GOBLINS_TRAP_KILL_NOTICE',
  payload: details,
  noServerSync: true
});

export const hideGoblinsTrapKillNotice = () => ({
  type: 'HIDE_GOBLINS_TRAP_KILL_NOTICE',
  noServerSync: true
});

// === City capture system ===
// timestamp — время захвата: от него идет окно облета захваченных городов во
// времени хода (cityCaptureTimeWindow). В сетевой партии его ставит сервер
export const captureCities = (guard = {}, timestamp) => ({
  type: 'CAPTURE_CITIES',
  payload: {
    ...guard,
    ...(timestamp ? {timestamp} : {}),
  }
});

export const showCityCaptureModal = () => ({
  type: 'SHOW_CITY_CAPTURE_MODAL',
  noServerSync: true
});

export const hideCityCaptureModal = () => ({
  type: 'HIDE_CITY_CAPTURE_MODAL',
  noServerSync: true
});

// Облет захваченных городов на поле (см. scenes/CityCaptureAnimation): пока он
// идет, модалка захвата и следующие за ней в очереди ждут
export const startCityCaptureAnimation = () => ({
  type: 'START_CITY_CAPTURE_ANIMATION',
  noServerSync: true
});

export const finishCityCaptureAnimation = () => ({
  type: 'FINISH_CITY_CAPTURE_ANIMATION',
  noServerSync: true
});

// Рост дохода руин на поле (см. scenes/RuinsIncomeAnimation): запрос ждет своей
// очереди за итогами раунда, анимация снимает запрос, когда начинается
export const requestRuinsIncomeAnimation = () => ({
  type: 'REQUEST_RUINS_INCOME_ANIMATION',
  noServerSync: true
});

export const cancelRuinsIncomeAnimationRequest = () => ({
  type: 'CANCEL_RUINS_INCOME_ANIMATION_REQUEST',
  noServerSync: true
});

export const startRuinsIncomeAnimation = () => ({
  type: 'START_RUINS_INCOME_ANIMATION',
  noServerSync: true
});

export const finishRuinsIncomeAnimation = () => ({
  type: 'FINISH_RUINS_INCOME_ANIMATION',
  noServerSync: true
});

// Гибель отрядов на поле (см. scenes/playUnitDeathEffects): пока она идет, итоги боя и
// следующие за ними в очереди ждут
export const startUnitDeathAnimation = () => ({
  type: 'START_UNIT_DEATH_ANIMATION',
  noServerSync: true
});

export const finishUnitDeathAnimation = () => ({
  type: 'FINISH_UNIT_DEATH_ANIMATION',
  noServerSync: true
});


export const showRoundEndModal = () => ({
  type: 'SHOW_ROUND_END_MODAL',
  noServerSync: true
});

export const hideRoundEndModal = () => ({
  type: 'HIDE_ROUND_END_MODAL',
  noServerSync: true
});

// Слепок промежуточных итогов на конец раунда (см. roundStandingsReducer).
// startedAt — момент старта партии: по нему слепок сверяется с партией
export const recordRoundStandings = (round, standings, startedAt) => ({
  type: 'RECORD_ROUND_STANDINGS',
  payload: {round, standings, startedAt},
  noServerSync: true
});

// === Combat system ===
// guard — слепок контекста хода (createPhaseActionGuard) на момент завершения
// этапа. Урон ближнего боя применяет клиент последнего подтвердившего, а если
// последние подтвердили одновременно и завершение не прислал никто — сервер
// (см. checkIfCombatStageReadyToComplete). Поздний дубль по слепку схлопывается
// в редьюсере no-op'ом, а не пересчитывает итоги боя по уже пустому урону
export const applyMeleeDamage = (guard) => ({
  type: 'APPLY_MELEE_DAMAGE',
  payload: {...guard},
});

// === Combat system ===
export const applyManeuverActions = () => ({
  type: 'APPLY_MANEUVER_ACTIONS',
  payload: {},
});

export const applyRecruitmentActions = () => ({
  type: 'APPLY_RECRUITMENT_ACTIONS',
  payload: {},
});

export const applyMovementActions = () => ({
  type: 'APPLY_MOVEMENT_ACTIONS',
  payload: {},
});

export const applyShootingActions = () => ({
  type: 'APPLY_SHOOTING_ACTIONS',
  payload: {},
});

// Модалку открывает modalsMiddleware у каждого клиента сам, в том числе на
// пришедший с сервера бой. Ретранслированный, чужой отклик поднимал флаг тому,
// кто модалку уже закрыл (см. combatResultsModalRelay.test.js)
export const showCombatResultsModal = () => ({
  type: 'SHOW_COMBAT_RESULTS_MODAL',
  noServerSync: true
});

export const hideCombatResultsModal = () => ({
  type: 'HIDE_COMBAT_RESULTS_MODAL',
  noServerSync: true
});

export const clearCombatResults = () => ({
  type: 'CLEAR_COMBAT_RESULTS',
  noServerSync: true
});

// Итоги этапа ждут конца ближнего боя, идущего следом: модалка закрыла бы удары
// и выбор цели (см. selectIsCombatResultsHeldForMelee)
export const holdCombatResultsForMelee = ({stage, playerId}) => ({
  type: 'HOLD_COMBAT_RESULTS_FOR_MELEE',
  payload: {stage, playerId},
  noServerSync: true
});

export const releaseCombatResultsForMelee = () => ({
  type: 'RELEASE_COMBAT_RESULTS_FOR_MELEE',
  noServerSync: true
});

// Новый этап перезаписывает gameState.combatResults, а игрок прежние итоги еще не
// закрыл: они остаются у него и показываются вместе с новыми
export const carryCombatResults = ({results, stats}) => ({
  type: 'CARRY_COMBAT_RESULTS',
  payload: {results, stats},
  noServerSync: true
});

// === Special buildings system ===
export const setSpecialBuilding = (hexKey, buildingType) => ({
  type: 'SET_SPECIAL_BUILDING',
  payload: {hexKey, buildingType}
});

// === Neutral units system (field preparation phase) ===
export const placeNeutralUnit = (hexKey, unitType, unitId) => ({
  type: 'PLACE_NEUTRAL_UNIT',
  payload: {hexKey, unitType, unitId},
  noServerSync: true
});

// Редактор миссий: отряд КОНКРЕТНОГО игрока на этапе расстановки поля
// (в обычном редакторе поля можно ставить только нейтральные отряды)
export const placeMissionUnit = (hexKey, unitType, unitId, ownerColor) => ({
  type: 'PLACE_MISSION_UNIT',
  payload: {hexKey, unitType, unitId, ownerColor},
  noServerSync: true,
});

export const removeNeutralUnit = (hexKey) => ({
  type: 'REMOVE_NEUTRAL_UNIT',
  payload: {hexKey},
  noServerSync: true
});

// === Unit upgrade system ===
export const upgradeUnit = (unitId, prevType, newType, price) => ({
  type: 'UNIT_UPGRADE',
  payload: {unitId, prevType, newType, price}
});

export const showUnitUpgradeModal = (unitId) => ({
  type: 'SHOW_UNIT_UPGRADE_MODAL',
  payload: {unitId},
  noServerSync: true
});

export const hideUnitUpgradeModal = () => ({
  type: 'HIDE_UNIT_UPGRADE_MODAL',
  noServerSync: true
});

export const showGameEndModal = () => ({
  type: 'SHOW_GAME_END_MODAL',
  noServerSync: true
});

export const hideGameEndModal = () => ({
  type: 'HIDE_GAME_END_MODAL',
  noServerSync: true
});

export const showInitiativeModal = () => ({
  type: 'SHOW_INITIATIVE_MODAL',
  noServerSync: true
});

export const hideInitiativeModal = () => ({
  type: 'HIDE_INITIATIVE_MODAL',
  noServerSync: true
});

export const addPendingShootingAction = (id, shooterUnitId, targetUnitId, targetHexKey, diceRoll1, diceRoll2, isBadLuck, isCentralQuarterDamageIgnored, damage, bonus, isUnitDamageOnly) => ({
  type: 'ADD_PENDING_SHOOTING_ACTION',
  payload: {
    id,
    shooterUnitId,
    targetUnitId,
    targetHexKey,
    diceRoll1,
    diceRoll2,
    isBadLuck,
    isCentralQuarterDamageIgnored,
    damage,
    bonus,
    isUnitDamageOnly,
  }
});

export const rerollPendingShootingAction = (id, diceRoll1, diceRoll2, isUnitTarget, isBadLuck, isDice1Selected, isDice2Selected, newDamage, newBonus) => ({
  type: 'REROLL_PENDING_SHOOTING_ACTION',
  payload: {id, diceRoll1, diceRoll2, isUnitTarget, isBadLuck, isDice1Selected, isDice2Selected, newDamage, newBonus}
});

export const addPendingManeuverAction = (unitId, fromHexKey, toHexKey) => ({
  type: 'ADD_PENDING_MANEUVER_ACTION',
  payload: {unitId, fromHexKey, toHexKey}
});

// Без unitId — отмена последнего маневра (кнопка отмены); с unitId — маневра
// этого отряда вне очереди (двойной клик по нему)
export const undoPendingManeuverAction = (unitId) => ({
  type: 'UNDO_PENDING_MANEUVER_ACTION',
  payload: unitId ? {unitId} : {},
});

export const toggleInitiativeInterception = () => ({
  type: 'TOGGLE_INITIATIVE_INTERCEPTION',
  payload: {},
});

// playerId — игрок, чей ход шел в момент открытия. По нему модалка отличает
// «мой ремонт» от ремонта, нажатого уже после смены ходящего игрока: ход мог
// завершиться таймером, пока модалка открыта, и ремонт уходил бы в
// pendingBuildings следующему игроку (см. RepairBuildingModal)
export const showRepairBuildingModal = (hexKey, playerId) => ({
  type: 'SHOW_REPAIR_BUILDING_MODAL',
  payload: {hexKey, playerId},
  noServerSync: true
});

export const hideRepairBuildingModal = () => ({
  type: 'HIDE_REPAIR_BUILDING_MODAL',
  noServerSync: true
});

export const showNoConstructionActionsModal = () => ({
  type: 'SHOW_NO_CONSTRUCTION_ACTIONS_MODAL',
  noServerSync: true
});

export const hideNoConstructionActionsModal = () => ({
  type: 'HIDE_NO_CONSTRUCTION_ACTIONS_MODAL',
  noServerSync: true
});

export const showSupplyFarmsConfirmModal = () => ({
  type: 'SHOW_SUPPLY_FARMS_CONFIRM_MODAL',
  noServerSync: true
});

export const hideSupplyFarmsConfirmModal = () => ({
  type: 'HIDE_SUPPLY_FARMS_CONFIRM_MODAL',
  noServerSync: true
});

export const showSupplyRedistributeConfirmModal = () => ({
  type: 'SHOW_SUPPLY_REDISTRIBUTE_CONFIRM_MODAL',
  noServerSync: true
});

export const hideSupplyRedistributeConfirmModal = () => ({
  type: 'HIDE_SUPPLY_REDISTRIBUTE_CONFIRM_MODAL',
  noServerSync: true
});

// Подтверждение завершения этапа войны, пока есть отряды, способные действовать
// и не пропустившие ход (change unit-auto-selection)
export const showWarStageUnitsConfirmModal = () => ({
  type: 'SHOW_WAR_STAGE_UNITS_CONFIRM_MODAL',
  noServerSync: true
});

export const hideWarStageUnitsConfirmModal = () => ({
  type: 'HIDE_WAR_STAGE_UNITS_CONFIRM_MODAL',
  noServerSync: true
});

export const repairBuilding = (hexKey, damage = 1, tokenLabel) => ({
  type: 'REPAIR_BUILDING',
  payload: {hexKey, damage, tokenLabel}
});

export const undoRepairBuilding = (hexKey, damage) => ({
  type: 'UNDO_REPAIR_BUILDING',
  payload: {hexKey, damage}
});

// === Auth & Lobby ===
export const setPlayerAuth = ({
                                name,
                                id,
                                // Гость: профиля еще нет, показан моковый
                                // (см. configs/guestProfile.js)
                                isGuest = false,
                                numens = 0,
                                crystals = 0,
                                rating = 0,
                                factionLoadouts = {},
                                unitSkins = [],
                                isNewItems = false,
                                isAllFactionsAvailable = false,
                                isAdmin = false,
                                isSuperAdmin = false,
                                isVideoMaker = false,
                                hasPassword = false,
                                hasAcceptedPrivacyPolicy = false,
                                hasAcceptedLicenseAgreement = false,
                                hasConfirmedAdult = false,
  hasSeenIntroSlides = false,
                                // Новость о рейтинговых обличиях: null — неизвестно (путь, не
                                // приславший признак), и тогда она не показывается
                                hasSeenRankSkinsNews = null,
                                // Анонс «Битвы с AI Claude Opus»: null — неизвестно (путь, не
                                // приславший признак), и тогда он не показывается; показ — только
                                // когда промо игроку открыто (isAiPromoAvailable)
                                hasSeenAiMatchNews = null,
                                // Игрок закрыл прежнюю редакцию анонса: текущая для него —
                                // известие о переменах (новое время матча)
                                isAiMatchNewsUpdate = false,
                                isAiPromoAvailable = false,
                                lastDoubleRewardAt = null,
                                dailyLoginRewardClaimedAt = null,
                                dailyLoginRewardStreak = 0,
                                premiumExpiresAt = null,
                                isActivePartner = false,
                                linkedToPartnerReferalId = null,
                                hasReceivedPartnerReferalRewards = null,
                                friendReferalCode = null,
                                referredByUserId = null,
                                hasReceivedFriendReferalRewards = null,
                                claimedLoginPromoIds = [],
                                receivedPurchaseInterestRewards = [],
                                completedTutorialChapters = [],
                                // Дата начисления награды за первый вход через
                                // установленное приложение (null — еще не начислялась)
                                appInstallRewardGrantedAt = null,
                                completedQuests = [],
                                localGamesPlayed = null,
                                onlineGamesPlayed = null,
                                rankedGamesPlayed = null
                              }) => ({
  type: 'SET_PLAYER_AUTH',
  payload: {
    name,
    id,
    isGuest,
    numens,
    crystals,
    rating,
    factionLoadouts,
    unitSkins,
    isNewItems,
    isAllFactionsAvailable,
    isAdmin,
    isSuperAdmin,
    // Видеомейкер: может смотреть запись любого матча (см. MatchDetailsPage)
    isVideoMaker,
    // Пароль есть только у аккаунтов по почте: по признаку настройки
    // показывают кнопку смены пароля (см. hasPassword в /auth/me)
    hasPassword,
    hasAcceptedPrivacyPolicy,
    hasAcceptedLicenseAgreement,
    // Подтверждение 18 лет на экране согласия (см. checkIfLegalConsentRequired)
    hasConfirmedAdult,
    hasSeenIntroSlides,
    hasSeenRankSkinsNews,
    hasSeenAiMatchNews,
    isAiMatchNewsUpdate,
    isAiPromoAvailable,
    lastDoubleRewardAt,
    dailyLoginRewardClaimedAt,
    dailyLoginRewardStreak,
    premiumExpiresAt,
    isActivePartner,
    linkedToPartnerReferalId,
    hasReceivedPartnerReferalRewards,
    // Публичный код для реферальных ссылок: без него страница приглашения и
    // приглашение в лобби откатываются на ссылку с id игрока
    friendReferalCode,
    referredByUserId,
    hasReceivedFriendReferalRewards,
    claimedLoginPromoIds,
    // Разовые подарки за интерес к покупке премиума/кристаллов: типы товаров,
    // по которым подарок уже выдан (см. configs/purchaseInterestRewards.js)
    receivedPurchaseInterestRewards,
    completedTutorialChapters,
    appInstallRewardGrantedAt,
    // Задания (см. src/configs/quests.js): id выполненных
    completedQuests,
    // Сыгранные сетевые матчи (без локальных и обучения) и из них
    // рейтинговые. null — сервер счетчик не прислал: тогда приглашения в
    // первый обычный/рейтинговый матч (utils/menuPromo) не показываются —
    // лучше промолчать, чем звать в «первый» матч ветерана
    localGamesPlayed,
    onlineGamesPlayed,
    rankedGamesPlayed
  },
  noServerSync: true
});

/**
 * Сыгран сетевой матч: сервер уже прибавил onlineGamesPlayed (и
 * rankedGamesPlayed у рейтингового) в finalizeGame, а /auth/me после матча
 * не перезапрашивается — счетчики в профиле двигаются локально, как нумены
 * и рейтинг (см. getOwnMatchResultProfileActions). Иначе приглашение в
 * «первый» обычный или рейтинговый матч (utils/menuPromo) могло бы всплыть в
 * этой же сессии игроку, который матч только что сыграл
 */
export const incrementOnlineGamesPlayed = ({isRanked = false} = {}) => ({
  type: 'INCREMENT_ONLINE_GAMES_PLAYED',
  payload: {isRanked},
  noServerSync: true,
});

/**
 * Сыграна локальная партия против ботов: сервер уже прибавил счетчик при
 * сохранении итогов (POST /api/users/me/local-matches), а /auth/me после
 * партии не перезапрашивается. Без локальной прибавки приглашение «сыграй с
 * ботами» всплыло бы в этом же заходе игроку, который бой только что провел
 */
export const incrementLocalGamesPlayed = () => ({
  type: 'INCREMENT_LOCAL_GAMES_PLAYED',
  noServerSync: true,
});

/**
 * Счетчик локальных партий по словам сервера: сохранение итогов возвращает
 * его нынешнее значение. В отличие от прибавки, выставление безопасно
 * повторять — им пользуется досылка итогов после перезагрузки страницы, где
 * неизвестно, учтен ли уже матч в только что загруженном профиле
 */
export const syncLocalGamesPlayed = (localGamesPlayed) => ({
  type: 'SYNC_LOCAL_GAMES_PLAYED',
  payload: {localGamesPlayed},
  noServerSync: true,
});

/**
 * Разовый подарок за интерес к покупке получен: балансы приходят с сервера
 * уже начисленными, а тип товара добавляется в список полученных, чтобы
 * модалка второй раз про награду не говорила
 */
export const applyPurchaseInterestRewardClaim = ({type, numens, crystals, premiumExpiresAt}) => ({
  type: 'APPLY_PURCHASE_INTEREST_REWARD_CLAIM',
  payload: {purchaseType: type, numens, crystals, premiumExpiresAt},
  noServerSync: true,
});

// Разовая награда за первый вход через установленное приложение начислена
// сервером (см. /api/users/me/app-install-reward): дата запоминается, чтобы
// клиент больше не просил награду, а сундук помечает коллекцию непросмотренной
export const applyAppInstallRewardGranted = ({grantedAt}) => ({
  type: 'APPLY_APP_INSTALL_REWARD_GRANTED',
  payload: {grantedAt},
  noServerSync: true,
});

// Игрок закрыл новость о рейтинговых обличиях (см. RankSkinsNewsModal):
// отмечаем сразу по клику, не дожидаясь сервера (markRankSkinsNewsSeen), —
// меню при следующем монтировании ее уже не покажет
export const setRankSkinsNewsSeen = () => ({
  type: 'SET_RANK_SKINS_NEWS_SEEN',
  noServerSync: true,
});

// Игрок закрыл анонс ежедневной «Битвы с AI Claude Opus» (см.
// AiMatchNewsModal): отмечаем сразу по клику, как и новость о рейтинговых
// обличиях, — сервер получит отметку следом (markAiMatchNewsSeen)
export const setAiMatchNewsSeen = () => ({
  type: 'SET_AI_MATCH_NEWS_SEEN',
  noServerSync: true,
});

// Награда по акции за вход получена: id акции добавляется в профиль, чтобы
// модалка акции больше не показывалась. Балансы приходят в том же ответе
// сервера и применяются отдельным applyLoginPromoRewardsClaim ниже
export const applyLoginPromoRewardsClaim = ({promoId, numens, crystals, premiumExpiresAt, hasNewItems}) => ({
  type: 'APPLY_LOGIN_PROMO_REWARDS_CLAIM',
  payload: {promoId, numens, crystals, premiumExpiresAt, hasNewItems},
  noServerSync: true
});

// Реферальная награда за регистрацию по ссылке партнера получена («Забрать
// дар»): обновляет балансы/премиум из ответа сервера и гасит модалку
// (hasReceivedPartnerReferalRewards = true) без повторного /auth/me
// hasNewItems приходит с сервера: метка «Новое» зажигается только если среди
// наград были предметы, видимые в коллекции (фракции, обличья, сундуки)
export const applyPartnerReferalRewardsClaim = ({numens, crystals, premiumExpiresAt, hasNewItems}) => ({
  type: 'APPLY_PARTNER_REFERAL_REWARDS_CLAIM',
  payload: {numens, crystals, premiumExpiresAt, hasNewItems},
  noServerSync: true,
});

// То же для награды программы «Пригласи друга»
// (hasReceivedFriendReferalRewards = true)
export const applyFriendReferalRewardsClaim = ({numens, crystals, premiumExpiresAt, hasNewItems}) => ({
  type: 'APPLY_FRIEND_REFERAL_REWARDS_CLAIM',
  payload: {numens, crystals, premiumExpiresAt, hasNewItems},
  noServerSync: true,
});

export const updateFactionLoadout = (factionId, loadout) => ({
  type: 'UPDATE_FACTION_LOADOUT',
  payload: {factionId, loadout},
  noServerSync: true,
});

export const clearFactionSkinSelection = (factionId) => ({
  type: 'CLEAR_FACTION_SKIN_SELECTION',
  payload: {factionId},
  noServerSync: true,
});

export const addOwnedUnitSkin = (unitSkinId) => ({
  type: 'ADD_OWNED_UNIT_SKIN',
  payload: {unitSkinId},
  noServerSync: true,
});

export const clearPlayerAuth = () => ({
  type: 'CLEAR_PLAYER_AUTH',
  noServerSync: true
});

export const updatePlayerRewards = (numensDelta, rating, isNewItems, crystalsDelta, isDoubleRewardClaimed) => ({
  type: 'UPDATE_PLAYER_REWARDS',
  payload: {
    numensDelta,
    rating,
    isNewItems,
    crystalsDelta,
    // Момент получения x2 за первый матч дня (редьюсер чистый — дату
    // проставляет криэйтор): обновляет auth.lastDoubleRewardAt без рефетча /me
    doubleRewardClaimedAt: isDoubleRewardClaimed ? new Date().toISOString() : undefined,
  },
  noServerSync: true
});

// Премиум начислен сервером (выпал из сундука) — обновляет дату истечения
// в профиле, чтобы иконка премиума и улучшенные бонусы включились сразу
export const setPremiumExpiresAt = (premiumExpiresAt) => ({
  type: 'SET_PREMIUM_EXPIRES_AT',
  payload: {premiumExpiresAt},
  noServerSync: true
});

// Ежедневная награда за вход получена: обновляет дату и счетчик дней подряд
// в профиле (баланс/isNewItems обновляются отдельным updatePlayerRewards)
export const setDailyLoginRewardClaimed = (claimedAt, streak) => ({
  type: 'SET_DAILY_LOGIN_REWARD_CLAIMED',
  payload: {claimedAt, streak},
  noServerSync: true,
});

export const setAvailableFactions = (factions) => ({
  type: 'SET_AVAILABLE_FACTIONS',
  payload: factions,
  noServerSync: true,
});

export const setIsAllFactionsAvailable = (isAllFactionsAvailable) => ({
  type: 'SET_IS_ALL_FACTIONS_AVAILABLE',
  payload: isAllFactionsAvailable,
  noServerSync: true,
});

export const setLobby = (lobbyData) => ({
  type: 'SET_LOBBY',
  payload: lobbyData,
  noServerSync: true
});

export const updateLobby = (lobbyData) => ({
  type: 'LOBBY_UPDATE',
  payload: lobbyData,
  noServerSync: true
});

export const leaveLobby = () => ({
  type: 'LEAVE_LOBBY',
  noServerSync: true
});
export const resetState = () => ({
  type: 'RESET_STATE',
  noServerSync: true
});

// FACTIONS

export const leprechaunsStealCoins = (unitId, playerId, coinsStolen) => ({
  type: 'FACTION_LEPRECHAUNS_STEAL_COINS',
  payload: {unitId, playerId, coinsStolen}
})

// unitId — юнит суккубов, пытающийся соблазнить; targetUnitId — цель;
// previousOwnerId — владелец цели ДО попытки (для тоста другим клиентам в
// playEffectForServerAction — после диспатча ownerId цели уже сменится).
// roll/attackerSize/targetSize/success считаются на клиенте (getD20Roll) и
// передаются готовыми, как и бросок Лепреконов/урон стрельбы, чтобы reducer
// оставался чистой функцией. attackerSize/targetSize хранятся отдельно (а не
// заранее посчитанной разницей) для футера с формулой (SelectedUnitSeduction) -
// там нужно отрисовать оба слагаемых по отдельности, каждое своим цветом
export const succubesSeduceUnit = (unitId, targetUnitId, previousOwnerId, roll, attackerSize, targetSize, success) => ({
  type: 'FACTION_SUCCUBES_SEDUCE_UNIT',
  payload: {unitId, targetUnitId, previousOwnerId, roll, attackerSize, targetSize, success}
})

// unitId — юнит гоблинов, пытающийся установить ловушку; trapId — заранее
// сгенерированный клиентом id новой ловушки (createRandomId,
// ID_PREFIX_FOR_GOBLINS_TRAP) — генерируется ДО диспатча, а не в reducer,
// чтобы reducer оставался чистой детерминированной функцией (одна и та же
// ловушка получит одинаковый id на всех клиентах при релее экшена); hexKey —
// цель; roll/success считаются на клиенте (getD6Roll)
export const goblinsSetTrap = (unitId, trapId, hexKey, roll, success) => ({
  type: 'FACTION_GOBLINS_SET_TRAP',
  payload: {unitId, trapId, hexKey, roll, success}
})

// unitId — юнит гоблинов, снимающий свою ловушку; trapId — id снимаемой
// ловушки (без броска кубика — снятие всегда успешно)
export const goblinsRemoveTrap = (unitId, trapId) => ({
  type: 'FACTION_GOBLINS_REMOVE_TRAP',
  payload: {unitId, trapId}
})

// unitId — юнит гоблинов, пытающийся повредить строение; hexKey — цель;
// roll/success считаются на клиенте (getD6Roll), урон/разрушение reducer
// вычисляет заново сам (calculateGoblinsBuildingDamageOutcome — та же функция,
// что и здесь) и как источник истины не доверяет полю destroyed из outcome.
// destroyed/buildingLabel в outcome посчитаны клиентом ДО диспатча тем же
// вызовом (см. GameScene.js) и нужны исключительно для тостов - и своего
// (сразу после диспатча), и чужих на других клиентах через
// playEffectForServerAction, которым иначе взять эти данные было бы неоткуда
// (после диспатча specialBuildings/hexes уже могут быть изменены). По той же
// причине сюда же добавлен victimPlayerId - владелец строения на момент
// клика (findOwner), чтобы отличить тост для жертвы от тоста для стороннего
// наблюдателя без пересчёта citiesCache постфактум
export const goblinsDamageBuilding = (unitId, hexKey, roll, success, outcome, victimPlayerId) => ({
  type: 'FACTION_GOBLINS_DAMAGE_BUILDING',
  payload: {unitId, hexKey, roll, success, ...outcome, victimPlayerId}
})

// unitId — перемещаемый вражеский (для владельцев ловушек) юнит; resolution —
// готовый результат resolveMovementWithTraps (finalHexKey, unitDied,
// remainingSize, killerPlayerId, triggeredTrapEvents, removedTrapIds) —
// считается на клиенте один раз синхронно до диспатча (см. design.md
// Decision 4/5), reducer применяет его как есть. resolution.isManeuver: true -
// если сработавшая ловушка была на этапе МАНЁВРА, а не перемещения (тот же
// резолвер маршрута, но разная бухгалтерия "отряд уже действовал в этом
// этапе" - reducer пишет в pendingManeuverActions вместо pendingMovementActions)
export const applyGoblinsTrapMovement = (unitId, resolution) => ({
  type: 'APPLY_GOBLINS_TRAP_MOVEMENT',
  payload: {unitId, ...resolution}
})

export const elementalsSetRandomElements = (tokens) => ({
  type: 'ELEMENTALS_SET_RANDOM_ELEMENTS',
  payload: {tokens}
})

// Жетоны элементов, вытянутые Элементалем при планировании строительства в
// чужой ход (см. elementalsPlanTokensByPlayerId). round и phase — слепок хода
// без ходящего игрока: действие шлет не ходящий, и сервер сверяет только
// раунд и фазу (см. buildGuardedRelayAction)
export const elementalsSetPlanTokens = (playerId = null, tokens = [], round = undefined, phase = undefined) => ({
  type: 'ELEMENTALS_SET_PLAN_TOKENS',
  payload: {playerId, tokens, round, phase}
})

export const elementalsSpendElement = (elementIndex) => ({
  type: 'ELEMENTALS_SPEND_ELEMENT',
  payload: {elementIndex}
})

// POLICIES
export const fanaticismConvertWinPoints = (playerId) => ({
  type: 'POLICY_FANATICISM_CONVERT_WIN_POINTS',
  payload: {...(playerId !== undefined && {playerId})},
})

export const agrarianismSwitchConversionOn = (playerId) => ({
  type: 'POLICY_AGRARIANISM_SWITCH_CONVERSION_ON',
  payload: {...(playerId !== undefined && {playerId})},
})
export const agrarianismSwitchConversionOff = (playerId) => ({
  type: 'POLICY_AGRARIANISM_SWITCH_CONVERSION_OFF',
  payload: {...(playerId !== undefined && {playerId})},
})
export const agrarianismSelectFarmForConversion = (farmHexKey, playerId) => ({
  type: 'POLICY_AGRARIANISM_SELECT_FARM_FOR_CONVERSION',
  payload: {farmHexKey, ...(playerId !== undefined && {playerId})},
})
export const agrarianismCommitConversion = (selectedFarmsForConversion, playerId) => ({
  type: 'POLICY_AGRARIANISM_COMMIT_CONVERSION',
  payload: {selectedFarmsForConversion, ...(playerId !== undefined && {playerId})}
})

export const showIsolationismModal = (hexKey) => ({
  type: 'SHOW_ISOLATIONISM_MODAL',
  payload: {hexKey},
  noServerSync: true
});
export const hideIsolationismModal = () => ({
  type: 'HIDE_ISOLATIONISM_MODAL',
  noServerSync: true
});

export const showConstructionPhaseInfoModal = (sectionId) => ({
  type: 'SHOW_CONSTRUCTION_PHASE_INFO_MODAL',
  payload: {sectionId},
  noServerSync: true
});

// Открытие/закрытие карточки фракции (оверлей из панели игроков или с
// кнопки завершения хода) — обучение отслеживает задания «открой карточку
// обоими способами» (предикат factionCardViewedFrom)
export const factionCardOverlayToggled = (isOpen, source) => ({
  type: 'FACTION_CARD_OVERLAY_TOGGLED',
  payload: {isOpen, source},
  noServerSync: true,
});

// Открытие/закрытие карточки политики (оверлей из панели игроков или с
// кнопки завершения хода) — обучение отслеживает задания «открой карточку»
// (предикат policyCardViewedFrom)
export const policyCardOverlayToggled = (isOpen, source) => ({
  type: 'POLICY_CARD_OVERLAY_TOGGLED',
  payload: {isOpen, source},
  noServerSync: true,
});

// Смена верхней боковой панели (список игроков <-> рынок политик) — зеркало
// состояния SideMenuStackContext: обучение отслеживает задания «переключись
// на панель списка игроков» (предикат sideMenuOnTop)
export const sideMenuBroughtToFront = (sideMenuId) => ({
  type: 'SIDE_MENU_BROUGHT_TO_FRONT',
  payload: {sideMenuId},
  noServerSync: true,
});

// Активный раздел открытых правил (дублируется из RulesModal): обучение
// отслеживает задания вида «открой раздел ...» (предикат rulesSectionOpened)
export const setRulesActiveSection = (sectionId) => ({
  type: 'SET_RULES_ACTIVE_SECTION',
  payload: {sectionId},
  noServerSync: true,
});

// Игрок пролистал страницу открытого раздела правил вниз: обучение
// отслеживает задания «пролистай страницу» (предикат rulesSectionScrolled)
export const rulesSectionScrolled = (sectionId) => ({
  type: 'RULES_SECTION_SCROLLED',
  payload: {sectionId},
  noServerSync: true,
});

export const hideConstructionPhaseInfoModal = () => ({
  type: 'HIDE_CONSTRUCTION_PHASE_INFO_MODAL',
  noServerSync: true
});

export const toggleHideModalsExceptGameEnd = () => ({
  type: 'TOGGLE_HIDE_MODALS_EXCEPT_GAME_END',
  noServerSync: true
});

export const setHideModalsExceptGameEnd = (value) => ({
  type: 'SET_HIDE_MODALS_EXCEPT_GAME_END',
  payload: value,
  noServerSync: true
});

// Сбрасывает флаги "открыта ли модалка X" (но не hideModalsExceptGameEnd —
// это отдельная пользовательская настройка отображения). Нужен, чтобы фоновая
// демо-партия в главном меню, которая крутится на том же сторе, не оставляла
// висящий showGameEndModal и т.п. к моменту
// старта настоящей партии (см. MenuDemoGame — вызывается при размонтировании)
export const resetModalVisibility = () => ({
  type: 'RESET_MODAL_VISIBILITY',
  noServerSync: true
});

export const isolationismInterceptInitiative = () => ({
  type: 'POLICY_ISOLATIONISM_INTERCEPT_INITIATIVE',
  payload: {},
})


// SERVER TO CLIENT ACTIONS (no direct handling with reducers, but with playEffectForServerAction only)

// noServerSync: сообщение формирует только сервер (откат стройки, когда ход
// дожал серверный таймер) и рассылает его с серверной меткой. От игрока не
// принимается — иначе сосед по лобби показал бы текущему игроку тост с любым
// текстом (см. redux/relayedActions)
//
// undone — что именно сервер отменил, для тех, кто читает не текст (MCP-агент):
// {usedFallback, keptCount, items: [{hexKey, token, kind, label, reason, errors}]}
// (см. rollbackInvalidPendingBuildings). Клиенту достаточно текста
export const sendConstructionValidationMessage = (validationMessage, undone) => ({
  type: 'SEND_CONSTRUCTION_VALIDATION_MESSAGE',
  payload: {validationMessage, ...(undone && {undone})},
  noServerSync: true
});

// Сюжетное появление стороны посреди миссии: добавляет игрока (если его ещё
// нет в партии) и спавнит его отряды. noServerSync: механика кампаний локальная
export const missionSpawn = (player, units) => ({
  type: 'MISSION_SPAWN',
  payload: {player, units},
  noServerSync: true,
});

// Сюжетный уход стороны: все отряды цвета снимаются с поля
export const missionDespawn = (color) => ({
  type: 'MISSION_DESPAWN',
  payload: {color},
  noServerSync: true,
});

// Передать игрока системе ботов прямо посреди партии (редактор миссий).
// noServerSync: миссии и редактор целиком локальные
export const setPlayerIsBot = (color, isBot) => ({
  type: 'SET_PLAYER_IS_BOT',
  payload: {color, isBot},
  noServerSync: true,
});

// Перехват управления ботом админом в сетевой игре (см. controlledBots).
// Экшен выпускает ТОЛЬКО сервер — после проверки прав в TAKE_BOT_CONTROL и
// RELEASE_BOT_CONTROL — и рассылает всем участникам. noServerSync — защита:
// сам клиент этот экшен на сервер не отправляет, иначе поставить пометку мог
// бы кто угодно
export const setBotController = (botPlayerId, controllerUserId) => ({
  type: 'SET_BOT_CONTROLLER',
  payload: {botPlayerId, controllerUserId: controllerUserId || null},
  noServerSync: true,
});

// Автопилот ИИ промо-матча (см. utils/aiPromo/aiAgentControl): включенное
// персональное время хода (isActive: true) — за ИИ играет сам агент со своим
// предохранителем, выключенное — серверный бот по стандартному времени.
// Длительность задана в START_GAME и здесь не меняется. Экшен выпускает
// ТОЛЬКО сервер и рассылает с серверной меткой; noServerSync — защита, как у
// перехвата бота: клиент его на сервер не отправляет, а сервер не
// ретранслирует (иначе выключить агенту время мог бы кто угодно)
export const setPlayerTurnTimeOverride = (playerId, isActive) => ({
  type: 'SET_PLAYER_TURN_TIME_OVERRIDE',
  payload: {playerId, isActive: Boolean(isActive)},
  noServerSync: true,
});

// === Сюжетные миссии: редактор и прохождение (всё чисто клиентское) ===

// Запуск режима редактора: дальше каждое игровое действие пишется в ленту
export const missionEditorStart = (draft) => ({
  type: 'MISSION_EDITOR_START',
  payload: {draft},
  noServerSync: true,
});

export const missionEditorUpdateDraft = (patch) => ({
  type: 'MISSION_EDITOR_UPDATE_DRAFT',
  payload: {patch},
  noServerSync: true,
});

export const missionEditorAddCharacterImage = (image) => ({
  type: 'MISSION_EDITOR_ADD_CHARACTER_IMAGE',
  payload: {image},
  noServerSync: true,
});

// Добавление записи в ленту миссии (действие, реплика, задание, авто-бот)
export const missionScriptAppend = (entry) => ({
  type: 'MISSION_SCRIPT_APPEND',
  payload: {entry},
  noServerSync: true,
});

export const missionScriptRemove = (entryId) => ({
  type: 'MISSION_SCRIPT_REMOVE',
  payload: {entryId},
  noServerSync: true,
});

// Старт прохождения записанной миссии. playerColor обязателен для проверки
// заданий: без него evaluateObjectives (missionMiddleware) не знает, за кого
// играет живой игрок, и миссию нельзя ни выиграть, ни проиграть
export const missionStart = (missionId, script, playerColor = null) => ({
  type: 'MISSION_START',
  payload: {missionId, script, playerColor},
  noServerSync: true,
});

// fromIndex — защита от двойного продвижения: редьюсер игнорирует экшен, если
// лента уже ушла с этого индекса (React.StrictMode в dev гоняет эффекты дважды,
// и без защиты MissionRunner перепрыгивал бы записи)
export const missionAdvanceScript = (fromIndex = null) => ({
  type: 'MISSION_ADVANCE_SCRIPT',
  payload: {fromIndex},
  noServerSync: true,
});

// С этого момента за игрока ходит обычная система ботов, а не запись
export const missionSetBotAuto = (color) => ({
  type: 'MISSION_SET_BOT_AUTO',
  payload: {color},
  noServerSync: true,
});

export const missionShowReplica = (replica) => ({
  type: 'MISSION_SHOW_REPLICA',
  payload: {replica},
  noServerSync: true,
});

export const missionCloseReplica = () => ({
  type: 'MISSION_CLOSE_REPLICA',
  noServerSync: true,
});

export const missionAddObjective = (objective) => ({
  type: 'MISSION_ADD_OBJECTIVE',
  payload: {objective},
  noServerSync: true,
});

export const missionSetCompletedObjectives = (completedObjectiveIds) => ({
  type: 'MISSION_SET_COMPLETED_OBJECTIVES',
  payload: {completedObjectiveIds},
  noServerSync: true,
});

export const missionSetProgress = (patch) => ({
  type: 'MISSION_SET_PROGRESS',
  payload: {patch},
  noServerSync: true,
});

export const missionFinished = (isFailed = false) => ({
  type: 'MISSION_FINISHED',
  payload: {isFailed},
  noServerSync: true,
});

// === Обучение (все экшены чисто клиентские) ===
// isRepeatRun — глава уже была пройдена раньше. Фиксируется на старте: список
// пройденных глав обновляется еще до показа поздравления, и метрики конца
// главы иначе приняли бы первое прохождение за повторное
export const tutorialStartChapter = (chapterId, {isRepeatRun = false} = {}) => ({
  type: 'TUTORIAL_START_CHAPTER',
  payload: {chapterId, isRepeatRun: Boolean(isRepeatRun)},
  noServerSync: true,
});

export const tutorialAdvanceStep = () => ({
  type: 'TUTORIAL_ADVANCE_STEP',
  noServerSync: true,
});

export const tutorialSetModal = (modalId) => ({
  type: 'TUTORIAL_SET_MODAL',
  payload: {modalId},
  noServerSync: true,
});

export const tutorialCloseModal = () => ({
  type: 'TUTORIAL_CLOSE_MODAL',
  noServerSync: true,
});

export const tutorialChapterCompleted = () => ({
  type: 'TUTORIAL_CHAPTER_COMPLETED',
  noServerSync: true,
});

// Сброс прогресса главы без выхода из партии: перемотка записи прохождения
// к началу (ReplayRunner) — иначе до первого действия записи был бы виден шаг,
// с которого перематывали
export const tutorialReset = () => ({
  type: 'TUTORIAL_RESET',
  noServerSync: true,
});

export const tutorialCompletionSaved = () => ({
  type: 'TUTORIAL_COMPLETION_SAVED',
  noServerSync: true,
});

// Обновление списка пройденных глав обучения в auth-стейте (ответ сервера на
// сохранение прогресса)
export const setCompletedTutorialChapters = (completedTutorialChapters) => ({
  type: 'SET_COMPLETED_TUTORIAL_CHAPTERS',
  payload: {completedTutorialChapters},
  noServerSync: true,
});

// Обновление списка пройденных миссий кампаний (ответ сервера на сохранение)
export const setCompletedCampaignMissions = (completedCampaignMissions) => ({
  type: 'SET_COMPLETED_CAMPAIGN_MISSIONS',
  payload: {completedCampaignMissions},
  noServerSync: true,
});

// Задание выполнено (награда за него уже начислена сервером): id уходит в
// auth-стейт, чтобы страница «Задания» и бейдж на кнопке профиля обновились
// без перезапроса профиля
export const addCompletedQuest = (questId) => ({
  type: 'ADD_COMPLETED_QUEST',
  payload: {questId},
  noServerSync: true,
});
